export interface Letter_Interface {
    id:Number,

    giver_name:String,
    giver_semat:String,

    subject_id:Number,
    subject_name:String,
    codePeygiri:String,

    reciver_Customer_id:Number,
    reciver_Customer_Dsc:String,

    draftTitle:String,
    takhfif:Number,
    arsh_afzoodeh:Number,
    peyvast:boolean,
    sex:boolean,
    bazgashtBeNamehShomareh:String,
    bazgashtBeNamehTarikh:String,
    pishPardakht:Number,
    khadamat:Number,

    textletter_id:Number,
    payam1_name:String,

    dsc:String,
    delivery:String,

    modirEdit_subject_id:boolean,
    modirEdit_sex:boolean,
    modirEdit_giver_name:boolean,
    modirEdit_giver_semat:boolean,
    modirEdit_takhfif:boolean,
    modirEdit_arsh_afzoodeh:boolean,
    modirEdit_pishPardakht:boolean,
    modirEdit_textletter_id:boolean,
}

export function Empty_Letter_Interface():Letter_Interface{
    return{
      id:0,

      giver_name:'',
      giver_semat:'',

      subject_id:0,
      subject_name:'',
      codePeygiri:'',

      reciver_Customer_id:0,
      reciver_Customer_Dsc:'',

      draftTitle:'',
      takhfif:0,
      arsh_afzoodeh:0,
      peyvast:true,
      sex:true,
      bazgashtBeNamehShomareh:'',
      bazgashtBeNamehTarikh:'',
      pishPardakht:0,
      khadamat:0,

      textletter_id:0,
      payam1_name:'',

      dsc:'',
      delivery: '',

      modirEdit_subject_id:false,
      modirEdit_sex:false,
      modirEdit_giver_name:false,
      modirEdit_giver_semat:false,
      modirEdit_takhfif:false,
      modirEdit_arsh_afzoodeh:false,
      modirEdit_pishPardakht:false,
      modirEdit_textletter_id:false,
    }
  }
